import axios from "axios";
import { throttleAdapterEnhancer } from 'axios-extensions';

axios.interceptors.request.use(
    config => {
        const throttleConfig = 2000;
        const token = localStorage.getItem("Access_Token");

        if (token !== null && token.toString().trim() !== "")
            config.headers = {
                "Authorization": `Bearer ${token}`,
                
            }

        config.adapter = throttleAdapterEnhancer(axios.defaults.adapter, { throttleConfig });
        return config;
    },

    error => {
        return Promise.reject(error);
    }
);

export default axios;